import './opt-out-confirm-form.scss';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { LoadingPane } from '@social-solutions/ssg-forms';
import { LegalSection, ssgFormsAdapters } from '../../common';
import { PropTypes } from 'prop-types';
import { renderLogo } from '../acct.util';
import { withRouter } from 'react-router-dom';
import * as optOutActions from './opt-out.actions';
import OptOutConfirmForm from './opt-out-confirm-form';
import queryString from 'query-string';
import React, { Component } from 'react';

/**
 * After verifying if the supplied token is still valid,
 * show the user a page to confirm yes/no for unsubscription.
 *
 * If the token is not valid, an invalid link error is displayed.
 */
export class OptOutComponent extends Component {

  componentDidMount() {
    const { optOutActions, location } = this.props;
    const { search } = location || {};
    const query = queryString.parse(search);
    const token = query.token;

    optOutActions.verifyUnsubToken(token)
      .catch(() => {});
  }

  handleSubmit() {
    const { optOutActions, location } = this.props;
    const { search } = location || {};
    const query = queryString.parse(search);
    const token = query.token;

    optOutActions.redeemUnsubToken(token)
      .catch(() => {});
  }

  render() {
    const { optOut, tenant, title } = this.props;

    var tokenValidityState = ssgFormsAdapters.convertLoadingState(optOut.valid);

    if(!tokenValidityState.isLoading && !tokenValidityState.error) {
      tokenValidityState.data = {};
    }

    if(!!tokenValidityState.error) {
      tokenValidityState.error.errorCode = 'invalid-unsub-token';
      tokenValidityState.error.errorMessage = 'This is no longer a valid link. Please contact your administrator about managing subscriptions.';
    }

    return (
      <div>
        <div id="opt-out-confirm">
          <LoadingPane id="opt-out-confirm-pane" loadingState={tokenValidityState} loadingMessage={"Verifying..."}>
            {renderLogo(tenant)}
            <div className="opt-out-confirm-form-container">
              <OptOutConfirmForm title={title} onHandleSubmit={()=>this.handleSubmit()}/>
            </div>
            <div id="legal-wrapper">
              <LegalSection />
            </div>
          </LoadingPane>
        </div>
      </div>

    );
  }
}

OptOutComponent.defaultProps = {
  title: "Confirmation",
};

OptOutComponent.propTypes = {
  title: PropTypes.string.isRequired,
};

const mapStateToProps = ({ optOut, tenant }) => {
  return {
    optOut,
    tenant,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    optOutActions: bindActionCreators(optOutActions, dispatch)
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OptOutComponent));



// WEBPACK FOOTER //
// src/acct/opt-out/opt-out.component.js